import { createOnAndOffNamespaceListeners, } from "../utils.js";
const listeners = createOnAndOffNamespaceListeners("app");
/**
 * Subcribes to an event on the app object.
 *
 * @param eventName - The event name to subscribe to.
 * @param callback - The callback function to execute when the event occurs.
 * @param options - ref: Reference for the Tray.
 * @returns event id.
 * @public
 */
export const addEventListener = listeners.addEventListener;
export const on = listeners.on;
/**
 * Unsusbcribes from an event on the app object.
 *
 * @param options - ref: Reference for the Tray; eventName: The event name to unsubscribe from; callback: eventId: The eventId that was returned from the initial `tray.on` invocation.
 * @public
 */
export const removeEventListener = listeners.removeEventListener;
export const off = listeners.off;
/**
 * Unsubscribes all listeners from the event name.
 *
 * @param options - ref: Reference for the Tray; eventName: The event name to unsubscribe from;
 * @returns Reference for the tray.
 * @public
 */
export const removeAllListeners = listeners.removeAllListeners;
